import {PaginationObject} from '../../../../../types/PaginationTypes';

/** Status values the UI knows how to label (others still render from `filter_data.statuses`). */
export const TALENT_POOL_STATUS_IDS = new Set(['pool', 'waiting_cv', 'match']);

/** Campaign option from `talent_pool.filter_data` (after camelCase). */
export type TalentPoolFilterCampaign = {
  resourceId: string;
  title: string;
};

export type TalentPoolFilterData = {
  campaigns: TalentPoolFilterCampaign[];
  statuses: string[];
};

/** `GET .../talent_pool/summary` payload under `talent_pool_summary` after camelCase. */
export type TalentPoolSummary = {
  testsTaken: number;
  testsPassed: number;
  /** From `applicants` in API; KPI label "Applications" / "Bewerber". */
  applicants?: number;
  matches: number;
  waitingCv: number;
  /** Fractional rate (e.g. `0.5` -> 50% in UI). */
  matchingQuota: number;
  /** Fractional or whole percent quota from BE for the "Test passed" stat subtitle. */
  testsPassedQuota?: number;
  /** Fractional or whole percent quota from BE for the "Applications" stat subtitle. */
  applicantsQuota?: number;
};

export type TalentPoolSummaryResponse = {
  talentPoolSummary: TalentPoolSummary;
};

/**
 * Placeholder for `useQueryPagination`'s status-count generic. The talent pool list API does not
 * return per-status totals; company matches use `GET .../matches/summary` instead of the list payload.
 */
export type TalentPoolPaginationStatusCounts = Record<string, number>;

/** One row from `GET .../talent_pool` after camelCase serialization. */
export type TalentPoolListItem = {
  resourceId: string;
  /**
   * Use for `talent_pool_profile/:id` when there is no match.
   */
  applicantResourceId?: string | null;
  /** Present when a recruiting match exists; use for match detail navigation instead of `resourceId`. */
  matchResourceId?: string | null;
  candidateName: string;
  campaignName: string | null;
  status: string;
  date: string;
  totalMatch: number | null;
  jobMatch: number | null;
  testMatch: number | null;
  cultureMatch: number | null;
};

export type TalentPoolPagination = PaginationObject;
